(function () {
  function localizedSelectWord() {
    var lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    var map = { fr: 'Sélectionnez', de: 'Wählen Sie', nl: 'Selecteer' };
    return map[lang] || 'Select';
  }

  function simplifyLabel() {
    var word = localizedSelectWord();

    document.querySelectorAll('.product-form__controls:has(.size-guide-btn) .product-form__group-name').forEach(function (el) {
      if (el.dataset.sgSimplified) return;
      el.dataset.sgSimplified = 'true';
      el.textContent = word;
    });

    document.querySelectorAll('.product-form__group-name').forEach(function (el) {
      if (el.dataset.sgSelectFixed) return;
      if (/^(\s*)Select(\s+)\S/.test(el.textContent)) {
        el.textContent = el.textContent.replace(/^(\s*)Select(\s+)/, '$1' + word + '$2');
      }
      el.dataset.sgSelectFixed = 'true';
    });
  }

  var CUSTOM_COLOR_HEX = {
    'sage-green': '#9CAF88',
    'terracotta': '#C65D3B',
    'charcoal': '#36454F',
    'viva-magenta': '#BB2649',
    'matcha-green': '#7B895B'
  };

  function colorHandleFromPath(path) {
    if (!path) return null;
    var m = path.match(/-in-([a-z0-9-]+?)\/?$/i);
    return m ? m[1].toLowerCase() : null;
  }

  function fixColorSwatches() {
    document.querySelectorAll('a.combined-color-swatch').forEach(function (el) {
      if (el.dataset.sgSwatchFixed) return;
      el.dataset.sgSwatchFixed = 'true';
      if (el.classList.contains('combined-color-swatch--solid')) return;

      var href = (el.getAttribute('href') || '').split('?')[0];
      var isCurrentProduct =
        el.classList.contains('combined-color-swatch--active') || href === location.pathname;
      var handle = colorHandleFromPath(href) || (isCurrentProduct ? colorHandleFromPath(location.pathname) : null);
      var hex = handle && CUSTOM_COLOR_HEX[handle];
      if (hex) {
        el.style.backgroundImage = 'none';
        el.style.backgroundColor = hex;
        el.classList.add('combined-color-swatch--solid');
      }
    });
  }

  function findAllSizeGuideTriggers() {
    var candidates = document.querySelectorAll('.product-popup__trigger');
    var matches = [];
    for (var i = 0; i < candidates.length; i++) {
      var trigger = candidates[i];
      var opener = trigger.closest('modal-opener');
      var modalSelector = opener && opener.getAttribute('data-modal');
      var modal = modalSelector ? document.querySelector(modalSelector) : null;
      if (modal && modal.querySelector('[data-cm], table')) {
        matches.push(trigger);
      }
    }
    return matches;
  }

  function isVisible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function hideOldSizeGuideRows() {
    if (!document.querySelector('.size-guide-btn')) return;
    findAllSizeGuideTriggers().forEach(function (trigger) {
      var row = trigger.closest('.product-popup');
      if (row && !row.dataset.sgHidden) {
        row.dataset.sgHidden = 'true';
        row.style.display = 'none';
      }
    });
  }

  simplifyLabel();
  hideOldSizeGuideRows();
  fixColorSwatches();

  var observer = new MutationObserver(function () {
    simplifyLabel();
    hideOldSizeGuideRows();
    fixColorSwatches();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener(
    'click',
    function (e) {
      var trigger = e.target.closest('.size-guide-btn');
      if (!trigger) return;

      var allTriggers = findAllSizeGuideTriggers();
      var realTrigger =
        allTriggers.find(function (t) {
          return isVisible(t.closest('.product-popup'));
        }) || allTriggers[0];

      if (realTrigger && realTrigger !== trigger) {
        e.preventDefault();
        e.stopImmediatePropagation();
        realTrigger.click();
      }
    },
    true
  );
})();
